// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Actions'">
    <refresh-button ng-show="\$ctrl.displayMode === 'NOT_OWNED' || \$ctrl.displayMode === 'OWNED'"
      on-refresh="\$ctrl.refresh()" class="sub-header__create-button">
    </refresh-button>
  </sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li ng-class="{'active': \$ctrl.displayMode === 'NOT_OWNED'}">
        <a data-target="#tab-to" data-toggle="#tab-to" ng-click="\$ctrl.setDisplayMode('NOT_OWNED')">
          <span>Sent to me</span>
          <span class="badge badge-important sidenav-actions-counter" ng-if="\$ctrl.taskCounters['NOT_OWNED'] > 0">
            {{\$ctrl.taskCounters['NOT_OWNED']}}
          </span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'OWNED'}">
        <a id="tab-header-by" data-target="#tab-by" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('OWNED')">
          <span>Sent by me</span>
          <span class="badge badge-important sidenav-actions-counter" ng-if="\$ctrl.taskCounters['OWNED'] > 0">
            {{\$ctrl.taskCounters['OWNED']}}
          </span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'EXECUTED_COMMANDS'}">
        <a data-target="#tab-to" data-toggle="#tab-cmd" ng-click="\$ctrl.setDisplayMode('EXECUTED_COMMANDS')">
          <span>Executed actions</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="filters" ng-if="\$ctrl.displayMode === 'NOT_OWNED' || \$ctrl.displayMode === 'OWNED'">
    <div class="labelled-field labelled-field--long">
      <label for="filter-branch" class="add-on">Branch</label>
      <select id="filter-branch" class="form-control" ng-disabled="!\$ctrl.branches || \$ctrl.branches.length < 2"
        ng-model="\$ctrl.filter.branch" ng-options="branch.name for branch in \$ctrl.branches" required>
      </select>
    </div>
    <div class="labelled-field labelled-field--long">
      <label for="filter-status" class="add-on">Status</label>
      <select id="filter-status" class="form-control" ng-model="\$ctrl.filter.status"
        ng-options="status.label for status in \$ctrl.statuses" required>
      </select>
    </div>
  </div>

  <div class="tab-content action-tab-content">

    <!-- SENT TO ME == NOT_OWNED -->

    <div class="tab-pane" id="tab-to" ng-class="{'active': \$ctrl.displayMode === 'NOT_OWNED'}">
      <div>
        <table class="table table--last-column-to-right" ng-table="\$ctrl.configs['NOT_OWNED']">
          <tr ng-repeat-start="item in \$data" class="table__row--clickable" ng-click="\$ctrl.rowClicked(item, \$event)"
            ng-class="{'selected': \$ctrl.selectedAction === item.id}">
            <td data-title="'No'">
              {{\$index+1 + (\$ctrl.currentConfig.page() - 1) * \$ctrl.currentConfig.count()}}
            </td>
            <td data-title="'Created on'">{{item.registrationTime | prettyDateTime }}</td>
            <td data-title="'Created by'">{{\$ctrl.formatUser(item.registrationUser)}}</td>
            <td data-title="'Type'" ng-class="\$ctrl.typeColor(item)">
              <span ng-if="item.taskGroup === 'COMMAND_APPROVAL'">{{item.name | translateEnum:'COMMAND'}}</span>
              <span ng-if="item.taskGroup !== 'COMMAND_APPROVAL'">{{item.name}}</span>
            </td>
            <td data-title="'Amount'">{{item.amount | nxCurrency }}</td>
            <td data-title="'Extra info'">{{item.extraInfo}}</td>
            <td data-title="'Actions'" class="table__actions">
              <approval-action ng-if="item.approvalStatus === 'PENDING'" level-label="Local override level"
                button-label="Local override" approval-action="\$ctrl.localOverrideAction"
                levels="\$ctrl.getLocalOverrideLevels(item)" button-class="btn-primary action-button"
                task="item"></approval-action>
              <approval-action ng-if="item.approvalStatus === 'PENDING' && item.canBeApproved"
                level-label="Approve level" button-label="Approve" approval-action="\$ctrl.approveAction"
                levels="\$ctrl.getApprovalLevels(item)" task="item"
                button-class="btn-success action-button"></approval-action>
              <button
                ng-if="item.approvalStatus === 'PENDING' || (\$ctrl.isExternalValidationRequired && item.approvalStatus === 'FOR_EXTERNAL_VALIDATION')"
                ng-show="item.canBeRejected" class="btn btn-danger action-button" type="button"
                ng-click="\$ctrl.reject(item, \$event)">
                Reject
              </button>
              <button ng-if="\$ctrl.isExternalValidationRequired && (item.approvalStatus === 'FOR_EXTERNAL_VALIDATION')"
                class="btn btn-primary action-button" type="button" ng-click="\$ctrl.validate(item, \$event)">
                Validate
              </button>
              <span ng-show="!\$ctrl.isExternalValidationRequired && (item.approvalStatus == 'FOR_EXTERNAL_VALIDATION')"
                class="status--warning">
                In External Validation
              </span>
              <span ng-show="item.approvalStatus === 'REJECTED'" class="status--danger">Rejected</span>
              <span ng-show="item.approvalStatus === 'APPROVED'" class="status--success">Approved</span>
            </td>
          </tr>
          <tr ng-repeat-end class="table__row--not-hoverable">
            <td colspan="100%">
              <div class="toggleable-panel-wrapper"
                ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedAction === item.id}">
                <dashboard-action-details action="item" on-hide="\$ctrl.hideDetailsPanel" on-success="\$ctrl.reloadData">
                </dashboard-action-details>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- SENT BY ME == OWNED -->

    <div class="tab-pane" id="tab-by" ng-class="{'active': \$ctrl.displayMode === 'OWNED'}">
      <div>
        <table class="table table--last-column-to-right" ng-table="\$ctrl.configs['OWNED']">
          <tr ng-repeat-start="item in \$data" class="table__row--clickable" ng-click="\$ctrl.rowClicked(item, \$event)"
            ng-class="{'selected': \$ctrl.selectedAction === item.id}">
            <td data-title="'No'">
              {{\$index+1 + (\$ctrl.currentConfig.page() - 1) * \$ctrl.currentConfig.count()}}
            </td>
            <td data-title="'Created on'">{{item.registrationTime | prettyDateTime }}</td>
            <td data-title="'Type'" ng-class="\$ctrl.typeColor(item)">
              <span ng-if="item.taskGroup === 'COMMAND_APPROVAL'">{{item.name | translateEnum:'COMMAND'}}</span>
              <span ng-if="item.taskGroup !== 'COMMAND_APPROVAL'">{{item.name}}</span>
            </td>
            <td data-title="'Amount'">{{item.amount | nxCurrency }}</td>
            <td data-title="'Extra info'">{{item.extraInfo}}</td>
            <td data-title="'Assigned to'">{{item.approvalUser ? \$ctrl.formatUser(item.approvalUser) : '-'}}</td>
            <td data-title="'Actions'" class="table__actions">
              <approval-action ng-if="item.approvalStatus === 'PENDING'" level-label="Local override level"
                button-label="Local override" approval-action="\$ctrl.localOverrideAction"
                levels="\$ctrl.getLocalOverrideLevels(item)" button-class="btn-primary action-button" task="item">
              </approval-action>
              <button ng-if="item.approvalStatus === 'PENDING'" ng-show="item.canBeRevoked"
                class="btn btn-danger action-button" type="button" ng-click="\$ctrl.revoke(item, \$event)">
                Reject
              </button>
              <span ng-show="!\$ctrl.isExternalValidationRequired && (item.approvalStatus == 'FOR_EXTERNAL_VALIDATION')"
                class="status--warning">
                In External Validation
              </span>
              <span ng-show="item.approvalStatus === 'REJECTED'" class="status--danger">Rejected</span>
              <span ng-show="item.approvalStatus === 'APPROVED'" class="status--success">Approved</span>
            </td>
          </tr>
          <tr ng-repeat-end class="table__row--not-hoverable">
            <td colspan="100%">
              <div class="toggleable-panel-wrapper"
                ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedAction === item.id}">
                <dashboard-action-details action="item" on-hide="\$ctrl.hideDetailsPanel" on-success="\$ctrl.reloadData">
                </dashboard-action-details>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- EXECUTED COMMANDS -->

    <div class="tab-pane" id="tab-cmd" ng-class="{'active': \$ctrl.displayMode === 'EXECUTED_COMMANDS'}">
      <action-commands ng-if="\$ctrl.displayMode === 'EXECUTED_COMMANDS'"></action-commands>
    </div>

  </div>


  <div ng-if="(\$ctrl.displayMode === 'NOT_OWNED' && \$ctrl.configs['NOT_OWNED'].data.length === 0) ||
              (\$ctrl.displayMode === 'OWNED' && \$ctrl.configs['OWNED'].data.length === 0)" class="empty-message">
    <span>No actions matching given criteria found.</span>
  </div>

  <local-override task="\$ctrl.overrideTask" on-pin-entered="\$ctrl.pinEntered(task, pin, user)">
  </local-override>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/actions/action-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;